import React from 'react';
import PropTypes from 'prop-types';

import { getTruthy } from 'utils/happyFunctions';
import { englishNumber } from 'utils/number';

import { IndicatorInput, QuestionBody, QuestionWrapper } from './styles';
import TitleInput from './TitleInput';
import DescriptionInput, {
  getDescriptionInputStatus,
} from './DescriptionInput';
import { Duration } from '../Duration/Duration';
import i18n, { languageDirection } from '../../i18n';
import Button from '../Button/Button';

class IndicatorQuestion extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      addDescription:
        !props.answer || (props.answer && !props.answer.description),
    };
  }

  shouldComponentUpdate(nextProps, nextState, nextContext) {
    return (
      nextProps.answer !== this.props.answer ||
      nextProps.question !== this.props.question ||
      nextProps.isRequired !== this.props.isRequired ||
      nextState !== this.state
    );
  }

  descriptionHandler = () => {
    this.setState({
      addDescription: !this.state.addDescription,
    });
  };

  handleChangeInput =
    (name, isTime = false) =>
    (e) => {
      const { answer } = this.props;
      let value = englishNumber(e.target.value);
      value = value.replace(/[^0-9-.]/g, '');
      const newAnswer = {
        ...answer,
        [name]: value,
      };
      if (isNaN(value)) {
        const floatNumberError = {
          [name]: i18n.t('justFloatNumberPermitted', { ns: 'survey' }),
        };
        newAnswer.error = answer
          ? { ...answer.error, ...floatNumberError }
          : floatNumberError;
      } else {
        if (newAnswer.error) {
          delete newAnswer.error[name];
          if (Object.keys(newAnswer.error).length === 0) {
            delete newAnswer['error'];
          }
        }
      }
      this.props.onChange(newAnswer, this.props.question.id);
    };

  handleChangeDescription = (description, _name) => {
    const answer = { ...this.props.answer, description };
    this.props.onChange(answer, this.props.question.id);
  };

  handleDuration = (duration, name) => {
    const { answer } = this.props;
    const newAnswer = { ...answer, [name]: duration };
    this.props.onChange(newAnswer, this.props.question.id);
  };

  render() {
    const {
      question,
      answer,
      isRequired,
      disabled,
      tags,
      survey,
      answers,
      questions,
    } = this.props;

    const descriptionStatus = survey
      ? getDescriptionInputStatus(survey, question)
      : true;

    const dir = languageDirection();
    return (
      <QuestionWrapper disabled={disabled}>
        <TitleInput
          fields={question.fields}
          hint={question.hint}
          required={question.answerRequired}
          title={question.title}
          tags={question.tags}
          allTags={tags}
          indexNumber={question.indexOrder}
          survey={survey}
          answers={answers}
          questions={questions}
        />
        <QuestionBody>
          <div className="row">
            <div className="container">
              <p
                className="col s12 m8 grid"
                style={{
                  textAlign: dir === 'ltr' ? 'left' : 'right',
                  float: dir === 'ltr' ? 'left' : 'right',
                }}
              >
                {question.numerator}
              </p>
              {question.numeratorUnit?.trim() ===
              i18n.t('hour', { ns: 'survey' }) ? (
                <Duration
                  id={`${question.id}-denominator`}
                  setDuration={this.handleDuration}
                  value={answer && answer.numerator ? +answer.numerator : 0}
                  isRequired={isRequired}
                  name={'numerator'}
                />
              ) : (
                <IndicatorInput
                  id={`${question.id}-denominator-id`}
                  autoComplete="off"
                  name={`${question.id}-numerator`}
                  onChange={this.handleChangeInput('numerator')}
                  placeholder={question.numeratorUnit}
                  required={isRequired}
                  type="text"
                  value={getTruthy(answer && answer.numerator, '')}
                  wrapperClassName="col s12 m4 grid"
                />
              )}
            </div>
            {answer && answer.error && answer.error.numerator && (
              <div className="col s4 grid">
                <span className="red-text">{answer.error.numerator}</span>
              </div>
            )}
            {question.denominator && (
              <div className="container">
                <p
                  className="col s12 m8 grid"
                  style={{
                    textAlign: dir === 'ltr' ? 'left' : 'right',
                    float: dir === 'ltr' ? 'left' : 'right',
                  }}
                >
                  {question.denominator}
                </p>
                {question.denominatorUnit?.trim() ===
                i18n.t('hour', { ns: 'survey' }) ? (
                  <Duration
                    id={`${question.id}-denominator`}
                    setDuration={this.handleDuration}
                    value={
                      answer && answer.denominator ? +answer.denominator : 0
                    }
                    isRequired={isRequired}
                    name={'denominator'}
                  />
                ) : (
                  <IndicatorInput
                    id={`${question.id}-denominator-id`}
                    autoComplete="off"
                    name={`${question.id}-denominator`}
                    onChange={this.handleChangeInput('denominator')}
                    placeholder={question.denominatorUnit}
                    required={isRequired}
                    type="text"
                    value={getTruthy(answer && answer.denominator, '')}
                    wrapperClassName="col s12 m4 grid"
                  />
                )}
                {answer && answer.error && answer.error.denominator && (
                  <div className="col s4 grid">
                    <span className="red-text">{answer.error.denominator}</span>
                  </div>
                )}
              </div>
            )}
          </div>

          {descriptionStatus && (
            <DescriptionInput
              question={question}
              survey={survey}
              open={!this.state.addDescription}
              handler={this.descriptionHandler}
              id={question.id}
              text={answer && answer.description}
              onChangeInput={this.handleChangeDescription}
              disabled={disabled}
            />
          )}
        </QuestionBody>
      </QuestionWrapper>
    );
  }
}

IndicatorQuestion.propTypes = {
  question: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  answer: PropTypes.object,
  disabled: PropTypes.bool,
  tags: PropTypes.object,
};

export default IndicatorQuestion;
